import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "../../assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import ReactTable from "react-table";

// Icons
//core components
import TextField from "@material-ui/core/TextField";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";
import green from "@material-ui/core/colors/green";
import DeleteModel from "../../components/Common/FevoModels/DeleteModel";
import { getCustomerData } from "../../actions/customerActions";
import toastr from "toastr";
import axios from "axios";
import { domain } from "../../utils/util";

class ManageCustomOfficers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showWarning: false,
      userToDeleteId: null,
      active: true,
      customerData: null,
      id: null,
      showreject: false,
      password: "",
      showPasswordPop: false,
    };
  }

  componentWillMount = () => {
    // this.props.fetchUsers()
    // this.props.getCustomerData();

    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
    axios
      .get(`${domain}/user/customs/appuser/list`, config)

      .then((res) => {
        if (res) {
          this.setState({
            customerData: res.data && res.data.data,
          });
        }
      })
      .catch((error) => {});
  };

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  getUserTableColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let column = [
      {
        Header: "Actions",
        accessor: "actions",
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center" },
        Cell: (props) => {
          return (
            <div className="actions-center">
              {props.original.request_forgot_password && (
                <Tooltip title="Send Password">
                  <IconButton
                    color="primary"
                    className={classes.button}
                    onClick={(e) => {
                      e.stopPropagation();
                      let id = props.original._id;
                      this.setState({
                        showPasswordPop: true,
                        id,
                      });
                    }}
                  >
                    <Icon>lock open</Icon>
                  </IconButton>
                </Tooltip>
              )}
              {props.original.profile_status == "unverified" ? (
                <div>
                  <Tooltip title="Approve">
                    <IconButton
                      color="primary"
                      className={classes.button}
                      onClick={(e) => {
                        e.stopPropagation();
                        let id = props.original._id;
                        this.setState({
                          showWarning: true,
                          id,
                        });
                      }}
                    >
                      <Icon>check</Icon>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Reject">
                    <IconButton
                      color="primary"
                      className={classes.button}
                      onClick={(e) => {
                        e.stopPropagation();
                        let id = props.original._id;
                        this.setState({
                          showreject: true,
                          id,
                        });
                      }}
                    >
                      <Icon>clear</Icon>
                    </IconButton>
                  </Tooltip>
                </div>
              ) : (
                <Tooltip title="view">
                  <IconButton
                    color="primary"
                    className={classes.button}
                    onClick={(e) => {
                      e.stopPropagation();

                      this.props.history.push("/admin/viewofficer", {
                        data: props.original,
                      });
                    }}
                  >
                    <Icon>visibility</Icon>
                  </IconButton>
                </Tooltip>
              )}
            </div>
          );
        },
      },
      {
        Header: "Profile Pic",
        Cell: (props) => {
          return (
            <img
              className={props.original.profile_pic ? "profile_pic" : null}
              src={props.original.profile_pic}
            />
          );
        },
      },
      {
        Header: "Full Name",
        accessor: "first_name",
      },
      {
        Header: "Email Address",
        accessor: "email",
      },
      {
        Header: "Gender",
        accessor: "gender",
      },
      {
        Header: "Badge Number",
        accessor: "badge_number",
      },
      {
        Header: "Type",
        accessor: "account_type",
      },
      // {
      //   Header: "Active",
      //   sortable: false,
      //   Cell: (props) => {
      //     return (
      //       <div>
      //         <Switch
      //           checked={props.original.isActive}
      //           onChange={(e) => { }}
      //           color="primary"
      //           name="active"
      //           inputProps={{ "aria-label": "primary checkbox" }}
      //         />
      //       </div>
      //     );
      //   },
      // },
    ];
    return column;
  };

  editCategoryFunc = (cat) => {
    if (cat) {
      let catObj = {
        _id: cat._id,
        images: cat.category_image,
        category_name: cat.category_name,
        category_description: cat.category_description,
        category_unit: cat.category_unit,
      };
      // this.props.categoryFormContent(catObj)
      this.props.history.push("/admin/addNewCategory", {
        categoryUnderView: catObj,
      });
    }
  };
  handlePassword = (e) => {
    let password = e.target.value;
    this.setState({
      password,
    });
  };
  cancelShowPassowordPop = () => {
    this.setState({
      id: null,
      showPasswordPop: false,
    });
  };

  sendPassword = () => {
    let { id, password } = this.state;
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
    if (password == "") {
      return toastr.error("Please enter the password!");
    }
    let body = {
      user_id: id,
      password,
    };
    axios
      .post(`${domain}/user/customs/send/password`, body, config)
      .then((res) => {
        if (res.data.statusCode === 200 || res.data.statusCode === 201) {
          toastr.success("Password Sent Successfully!");
          this.setState({
            showPasswordPop: false,
            id: null,
          });
          setTimeout(function() {
            window.location.reload();
          }, 2000);
        } else if (res && res.data && res.data.statusCode === 401) {
          localStorage.removeItem("BerPay_Admin");
          this.props.history.push("/admin/pages/login-page");
        }
      })
      .catch((error) => {});
  };
  render() {
    const {
      showWarning,
      customerData,
      showreject,
      password,
      showPasswordPop,
    } = this.state;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardBody>
                {showPasswordPop && (
                  <div className="cust_pop">
                    <div className="password_filed">
                      <GridItem xs={12}>
                        <TextField
                          autoFocus
                          margin="dense"
                          name="password"
                          id="password"
                          label="Enter the password"
                          type="text"
                          //disabled={!isEdit && !addCategory}
                          onChange={(e) => this.handlePassword(e)}
                          fullWidth
                          value={password}
                          style={{ marginBottom: "20px" }}
                          required
                        />
                      </GridItem>

                      <div className="button">
                        <span onClick={this.cancelShowPassowordPop}>
                          Cancel
                        </span>
                        <span onClick={this.sendPassword}>Send</span>
                      </div>
                    </div>
                  </div>
                )}
                <ReactTable
                  data={customerData ? customerData : []}
                  columns={this.getUserTableColumn()}
                  defaultPageSize={20}
                  pageSizeOptions={[5, 10, 20, 25, 50]}
                  showPaginationBottom={true}
                  minRows={4}
                  // manual
                  noDataText="No Custom Officer found"
                  onPageChange={(pageIndex) => {
                    console.log(pageIndex);
                    // let newQuery = getUserQuery;
                    // newQuery["offset"] = pageIndex * newQuery.limit;
                    // updateQueries(newQuery);
                    // getUserData(newQuery);
                  }}
                  onPageSizeChange={(rowPerPage) => {
                    console.log(rowPerPage);
                    // let newQuery = getUserQuery;
                    // newQuery["limit"] = rowPerPage;
                    // updateQueries(newQuery);
                    // getUserData(newQuery);
                  }}
                  // getTrProps={(state, rowInfo, column, instance) => {
                  //   return {
                  //     onClick: (e, handleOriginal) => {
                  //       if (rowInfo) {
                  //         // this.editCategoryFunc(rowInfo.original)
                  //       }
                  //     },
                  //     // style: {
                  //     //   cursor: 'pointer',
                  //     //   background: rowInfo && rowInfo.viewIndex%2 === 0 ? '#f9eddb' : '#e0d2be'
                  //     // }
                  //   };
                  // }}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>

        <DeleteModel
          showModel={showWarning}
          title={"Are you sure you want to approve the Officer?"}
          onCancel={() => {
            this.setState({
              showWarning: false,
              id: null,
            });
          }}
          onOk={() => {
            let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
            let config = {};
            if (data) {
              config = {
                headers: { Authorization: `Bearer ${data.token}` },
              };
            }
            let id = this.state.id;
            let body = {
              id: id,
              profile_status: "verified",
            };
            axios
              .put(`${domain}/user/update/appuser`, body, config)
              .then((res) => {
                if (
                  res.data.statusCode === 200 ||
                  res.data.statusCode === 201
                ) {
                  toastr.success("Officer Approved Successfully!");
                  this.setState({
                    showWarning: false,
                    id: null,
                  });
                  setTimeout(function() {
                    window.location.reload();
                  }, 2000);
                }
              })
              .catch((error) => {});
          }}
        />
        <DeleteModel
          showModel={showreject}
          title={"Are you sure you want to reject the Officer?"}
          onCancel={() => {
            this.setState({
              showreject: false,
              id: null,
            });
          }}
          onOk={() => {
            let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
            let config = {};
            if (data) {
              config = {
                headers: { Authorization: `Bearer ${data.token}` },
              };
            }
            let id = this.state.id;
            let body = {
              id: id,
              profile_status: "reject",
            };
            axios
              .put(`${domain}/user/update/appuser`, body, config)
              .then((res) => {
                if (
                  res.data.statusCode === 200 ||
                  res.data.statusCode === 201
                ) {
                  toastr.success("Officer Rejected Successfully!");
                  this.setState({
                    showreject: false,
                    id: null,
                  });
                  setTimeout(function() {
                    window.location.reload();
                  }, 2000);
                }
              })
              .catch((error) => {});
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // users: state.products.categories
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomerData: () => dispatch(getCustomerData()),
    // fetchCategories: ()=> dispatch(fetchCategories()),
    // categoryFormContent: (obj) => {dispatch({type:PRODUCT_CATEGORY_ACTION.OPEN_CATEGORY_FORM,payload:obj})},
    // editCategory: (obj) => dispatch(editCategory(obj)),
    // deleteCategory: (obj,callback) => dispatch(deleteCategory(obj,callback)),
  };
};

const ManageCustomerOfficerComponent = withStyles(extendedTablesStyle)(
  ManageCustomOfficers
);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCustomerOfficerComponent);
